import React, { useState, useEffect } from 'react';
import { Layout, Drawer } from 'antd';
import Sidebar from './Sidebar';
import Header from './Header';

const { Content } = Layout;

const AppLayout = ({ children }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Hide sidebar fully by default on mobile load
    useEffect(() => {
        if (isMobile) {
            setCollapsed(true);
        }
    }, [isMobile]);

    return (
        <Layout style={{ minHeight: '100vh' }}>
            {isMobile ? (
                <Drawer
                    placement="left"
                    closable={false}
                    onClose={() => setCollapsed(true)}
                    open={!collapsed}
                    styles={{ body: { padding: 0 } }}
                    width={200}
                >
                    <Sidebar collapsed={false} isMobile={true} setCollapsed={setCollapsed} />
                </Drawer>
            ) : (
                <Sidebar collapsed={collapsed} isMobile={false} />
            )}
            
            <Layout style={{
                transition: 'all 0.2s',
                marginLeft: isMobile ? 0 : (collapsed ? 80 : 200),
                background: '#f0f2f5'
            }}>
                <Header collapsed={collapsed} setCollapsed={setCollapsed} />
                <Content
                    style={{
                        margin: isMobile ? '16px' : '24px',
                        padding: isMobile ? 16 : 24,
                        minHeight: 280,
                        background: '#fff',
                        borderRadius: '8px',
                    }}
                >
                    {children}
                </Content>
            </Layout>
        </Layout>
    );
};

export default AppLayout;
